/**
 * Telegram Mini App wrapper for package checkout.
 * URL: /tg/p/:cardKey/checkout
 *
 * Reuses Checkout — TelegramShell does the initData → JWT handshake, after
 * which the ordinary component runs with auth in context.
 *
 * This exists because the bot's "Unlock everything" button pointed at
 * /tg/p/uat-aau/checkout and no such route was ever declared: the URL fell
 * through to the SPA and rendered nothing. The bot could offer the package and
 * not sell it.
 *
 * Only checkout is wrapped, not the whole shell. Lessons and questions are
 * served in the CHAT by the bot's own handlers, which is the better surface for
 * them; paying is the one thing chat cannot do, because it needs a file picker
 * for the receipt.
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import TelegramShell from '../components/TelegramShell';
import Checkout from './Checkout';

const TelegramCheckout: React.FC = () => {
  // `Checkout` reads :cardKey from the route itself, so the param only has to
  // be present in the path — nothing to thread through.
  useParams();
  return (
    <TelegramShell>
      <Checkout />
    </TelegramShell>
  );
};

export default TelegramCheckout;
